/* eslint-disable */
import React, { Component, Fragment } from 'react';
import { Modal, Button, Tab, Input, Label, SearchBox,TextArea, Select } from '@posco/posco-ui-react';
import { mesAutobind, context } from '@posco/posco-shared';

/**사외로그인화면의 개인정보처리방침** /
 *
 */
@mesAutobind
class O10g015462 extends Component {
    state ={
      open : false,
      editeState: false,

};

    handleSave() {
        console.log('save');
    }

    handleCancel() {
      console.log('cancel');
    }

    /**모달 닫기**/
  onClose() {
    // this.props.o10g015460Store.changeDisabled(true)
      // console.log("321321321");
    this.props.close();
  }

  /*******조회(searchBox)******/
  async searchButton(e, data) {
    console.log("E, DATA", e, data);
    console.log("this.props.o10g015460Store.version",this.props.version);
    await this.props.onFindExpl(this.props.version);
    console.log("조회 : this.props.explan::: ", this.props.explan);
    this.dext5load(this.props.explan && this.props.explan.manPrcStexExpl1, "view");
  }

  onSearch(valueMap) {
    alert(`검색조건: ${JSON.stringify(valueMap, null, 2)}`);
  }

  /* DevEditor DOM 삽입 */
  loadJs(uri) {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.async = true;
      script.src = uri;
      document.head.appendChild(script);
      script.onload = resolve;
    });
  }

  // 에디터 로드 완료 후 실행되는 메소드
  dextEditorLoaded() {

  }

  async dext5load(data, mode) {
    console.log("`${context.path()}", `${context.path()}`)
    await this.loadJs(`${context.path()}/dext5editor/js/dext5editor.js`).then(async (a) => {
      DEXT5.config.PasteImageBase64 = "1";        // 이미지 캡쳐를 위해 사용
      DEXT5.config.UploadMethod = "base64";       // 이미지를 에디터에 넣을경우 base64 형태의 데이터로 받기
      DEXT5.config.ShowTopMenu = '0';             // Menu바 출력 X
      DEXT5.config.ShowStatusBar = '1';           // Status바 출력 X
      // DEXT5.config.Width = '100%';               // 에디터 넓이 조절
      DEXT5.config.Height = '500px';              // 에디터 높이 조절
      DEXT5.config.Event.LoadedEvent = this.dextEditorLoaded; //에디터 초기 로딩 끝나고 발생하는 이벤트
      DEXT5.config.Mode = mode; //"edit": 수정(editable), "view":보기만 가능


      DEXT5.config.EditorHolder = 'manPrcStexExpl1';  // 에디터를 생성할 div의 id //개인정보처리방침
      if (document.querySelector('#manPrcStexExpl1')) {
        // await new Dext5editor('docCont');             // 에디터의 이름
        await new Dext5editor('manPrcStexExpl1');             // 에디터의 이름
      }
    });

    //set
    // DEXT5.setHtmlValueEx( this.state.selectedRow.stdAttCngRsn, 'stdAttCngRsn' );

    //등록: data-> null
    //수정: data -> this.state.selectedRow
    //버전: data -> target
    if(data) {
      console.log("Data:::::", data);
      DEXT5.setHtmlValueEx( data, 'manPrcStexExpl1' );
      // DEXT5.setHtmlValueEx( data.manPrcStexExpl2, 'manPrcStexExpl2' );
      // DEXT5.setHtmlValueEx(  data.manPrcStexExpl3, 'manPrcStexExpl3' );
    }
  }

 async handleOpenPreview(data) {
    console.log("data::::", data);
    let previewText = data;
    if (document.getElementById(data)) {
      document.getElementById(data).innerHTML = previewText;
    }
    await this.props.setExplan({ ...this.props.explan, manPrcStexExpl1 : previewText });

   console.log("previewText:::::", this.props.explan.manPrcStexExpl1);
    return this.props.explan;
  }

  render() {

    const {  } = this.state;

        return (
            <Fragment>
              {/*<Modal trigger={<a onClick={} >{"개인정보처리방침"}</a>} onClose={this.handleClose} size={'small'} className="agreementModal" >*/}
              <Modal trigger={<button onClick={async() => await this.handleOpenPreview(this.props.explan && this.props.explan.manPrcStexExpl1)} >개인정보처리방침</button>} onClose={this.onClose} size={'small'} className="agreementModal" >
                    <Modal.Header content="개인정보처리방침" />
                    <Modal.Content>
                    <section className="o10g015170">
                              <div className="gridRow">
                                <div className="gridColumn">
                                  <div className="h4wrap" >
                                    <h4>version</h4>
                                  </div>
                                  <div  className="srcBox" style={{background:"white" ,padding:"0px"}}>
                                    <SearchBox
                                      background={"white"}
                                      style={{background:"white" ,padding:"0px"}}
                                      toggleDisabled
                                      defaultButtonHidden
                                      buttonAdditionalNode={
                                        <Fragment>
                                          <Button className="btnSearch" onClick={this.searchButton}>조회</Button>
                                        </Fragment>
                                      }
                                      onSearch={this.onSearch}
                                    >
                                      <SearchBox.Fields>
                                        <SearchBox.Field>
                                          <Select
                                            options={this.props.searchVersion}
                                            value={this.props.version}
                                            onChange={this.props.handleSelectChange}
                                          />
                                        </SearchBox.Field>
                                      </SearchBox.Fields>
                                    </SearchBox>
                                    </div>
                      <div className="srcWrap"
                        dangerouslySetInnerHTML={{__html: this.props.explan.manPrcStexExpl1}}>
                                  {/*<textarea  className="alotTextLogin"*/}
                                  {/*           readOnly={true}*/}
                                  {/*           style={{backgroundColor:"white"} }*/}
                                  {/*           // rows="20"*/}
                                  {/*          value={this.props.explan && this.props.explan.manPrcStexExpl1} >*/}
                                  {/*</textarea>*/}
                        {/*<table>*/}
                        {/*  <tbody>*/}
                        {/*  <tr>*/}
                        {/*    <td>*/}
                        {/*      <div id="manPrcStexExpl1" />*/}
                        {/*    </td>*/}
                        {/*  </tr>*/}
                        {/*  </tbody>*/}
                        {/*</table>*/}
                      </div>

                      </div>
                      </div>
                    </section>
                  </Modal.Content>
                  </Modal>
            </Fragment>
        )
    }

}
export default O10g015462;
